import { styled } from '@acko-tech/building-blocks.ui.common';

export const FAQsContainer = styled.div`
  padding: ${(props) => (props?.addPadding ? '30px 20px' : '')};
  max-width: ${(props) => (props?.addMax ? '620px' : 'unset')};
  width: ${(props) => `${props?.width}px`};
  background: ${(props) =>
    `${
      props?.showBackground
        ? 'linear-gradient(180deg, rgba(240, 240, 246, 0.6) 0%, rgba(248, 247, 252, 0) 100%)'
        : ''
    }`};

  @media screen and (min-width: 768px) {
    max-width: 100%;
    width: 100%;
  }
`;

export const SectionTitle = styled.div`
  width: 100%;
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 2rem;
  margin: ${(props) => props.margin || '30px 0'};
  padding-left: ${(props) => props.left || '0'};
  text-align: ${(props) => props.align};

  @media screen and (min-width: 768px) {
    font-weight: 700;
    font-size: 2rem;
    line-height: 2.5rem;
  }
`;

export const Accordion = styled.div`
  margin-top: 10px;
`;

export const AccordionMobileDropdown = styled.div`
  transition: all 0.45s ease-in;
  transform: ${(props) => (props?.rotate ? 'rotate(180deg)' : 'rotate(0deg)')};
  min-width: 12px;
`;

export const AccordionHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
  padding-bottom: 20px;
  position: relative;

  @media screen and (min-width: 768px) {
    padding-bottom: 20px;
  }
`;

export const AccordionItem = styled.div`
  border-bottom: 1px solid #e7e7f0;
  margin-bottom: 24px;
  cursor: pointer;

  @media screen and (min-width: 768px) {
    padding: 24px;
    border-radius: 24px;
    width: 100%;
    border-bottom: unset;
    background: rgb(255, 255, 255);
    margin-bottom: 24px;
    border: 1px solid rgb(231, 231, 240);

    ${(props) => props && props.accordionItemStyles};
  }
`;

export const Title = styled.div`
  font-weight: ${(props) => (props?.weight ? '500' : '400')};
  font-size: 1rem;
  line-height: 1.5rem;
  transition: all 0.1s ease-in;

  @media screen and (min-width: 768px) {
    font-size: 1.5rem;
    line-height: 2rem;
  }
`;

export const Desc = styled.div`
  height: ${(props) => (!props?.open ? '0' : 'unset')};
  opacity: ${(props) => (props?.open ? '1' : '0')};
  overflow: hidden;
  padding-bottom: ${(props) => (props?.open ? '20px' : '0')};
  font-weight: 400;
  color: #5b5675;
  font-size: 0.875rem;
  line-height: 1.25rem;
  transition: all 0.3s ease-in;

  @media screen and (min-width: 768px) {
    padding-bottom: unset;
    margin-right: 40px;
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
`;

export const Action = styled.div`
  font-weight: 500;
  color: #1b73e8;
  font-size: 0.875rem;
  line-height: 1.25rem;
  margin-top: -10px;
  cursor: pointer;
`;

export const Rotate = styled.div`
  position: absolute;
  top: ${(props) => (props?.open ? '0' : '-1.5px')};
  left: ${(props) => (props?.open ? '0' : '-1px')};
  transform: ${(props) => (props?.open ? 'rotate(0deg)' : 'rotate(90deg)')};
  transition: all 0.2s ease-in;
`;

export const AccordionDesktopDropdown = styled.div`
  position: absolute;
  right: 0;
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.375rem;
  transition: all 0.3s ease-in;
  transform: ${(props) => (props?.rotate ? 'rotate(180deg)' : 'rotate(0deg)')};
`;
